export default class MobNav {
  constructor() {
    this.burger = document.querySelector('[data-burger]');
    if (!this.burger) return;
    this.nav = document.querySelector('[data-nav]');
    this.breakpoint = window.matchMedia('(max-width: 1200px)');
    this.navClose = document.querySelector('[data-mob-nav-close]');
    this.secondLevels = document.querySelectorAll(
      '[data-header-meta-second-level]',
    );

    this.handleBurgerClick();
    this.handleBreakpointChange();
    this.handleNavClose();
    this.handleSecondLevel();
  }

  handleBurgerClick() {
    this.burger.addEventListener('click', () => {
      this.nav.classList.toggle('open');
    });
  }

  handleBreakpointChange() {
    this.breakpoint.addEventListener('change', () => {
      this.nav.classList.remove('open');
    });
  }

  handleNavClose() {
    this.navClose.addEventListener('click', () => {
      this.nav.classList.remove('open');
    });
  }

  handleSecondLevel() {
    this.secondLevels.forEach((sLevel) => {
      const thirdLevel = sLevel.querySelector('ul');
      if (thirdLevel) {
        const clickContainer = sLevel.querySelector(
          '[ data-header-meta-click-container]',
        );
        clickContainer.addEventListener('click', () => {
          sLevel.classList.toggle('open');
          thirdLevel.classList.toggle('open');
        });
      }
    });
  }
}
